<template>
  <div class="animated fadeIn">
    <div class="row mb-20">
      <div class="col-6">
        <a @click="openPage('/allForm')" class="btn-grey">
          <i class="fas fa-arrow-circle-left mr-5"></i>Back
        </a>
      </div>
    </div>
    <div class="box">
      <div class="p-20">
        <div class="row mt-10">
          <div class="col-sm-6">
            <b-row>
              <b-col sm="3">
                <label>Type</label>
              </b-col>
              <b-col sm="9">
                <b-form-select @change="changeFormType" name="formType" v-model="formType" :options="options"
                  class="mb-3" />
              </b-col>
            </b-row>
          </div>
          <div class="col-sm-6">
            <b-row>
              <b-col sm="3">
                <label>Branch</label>
              </b-col>
              <b-col sm="9">
                <b-form-select name="branch" v-model="addData.branch_id" @change="changeBranch">
                  <option :value="null">Please select</option>
                  <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{ item.name }}</option>
                </b-form-select>
                <div v-if="branch_validate">
                  <span class="error">The Branch field is required.</span>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
        <template v-if="formType === 'outstanding'">
          <form @submit.prevent="validateOutstanding('outstanding')" data-vv-scope="outstanding">
            <div class="row justify-content-center mt-30">
              <div class="col-sm-6">
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Member ID</label>
                  </b-col>
                  <b-col sm="9">
                    <div class="custom-search-select">
                      <model-select @searchchange="searchMember" :options="optionsMember" class="border-bottom"
                        name="member_id" v-validate="'required'" v-model="addData.member_id"></model-select>
                    </div>
                    <span class="error">{{ errors.first('outstanding.member_id') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Member Name</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom bg-transparent" disabled v-model="fullNameDetail"
                      type="text"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Phone Number</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom bg-transparent" disabled v-model="detailMember.phone_number"
                      type="text"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Email</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom bg-transparent" disabled v-model="detailMember.email"
                      type="text"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Membership Type</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom bg-transparent" disabled
                      v-model="detailMember.membership_last_buy_name" type="text"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Join Date</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom bg-transparent" disabled v-model="detailMember.start_membership"
                      type="text"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Category</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-select name="branch" v-model="addData.outstanding_category_id">
                      <option :value="1">Outstanding</option>
                      <option :value="2">In Advance</option>
                      <option :value="3">Other Payment</option>
                      <option :value="4">Manual Invoice</option>
                    </b-form-select>
                    <div v-if="addData.outstanding_category_id == null">
                      <span class="error">The Category field is required.</span>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mb-20" v-if="detailMember.membership">
                  <b-col sm="3">
                    <label>Monthly Price</label>
                  </b-col>
                  <b-col sm="9">
                    <money class="form-control border-bottom custom-currency w-100 bg-transparent" disabled
                      v-model="detailMember.membership_last_buy_price" name="late_payment_total" v-bind="money2">
                    </money>
                  </b-col>
                </b-row>
              </div>
              <div class="col-sm-6">
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Month</label>
                  </b-col>
                  <b-col sm="9">
                    <div class="row">
                      <div class="col-6">
                        <b-form-select :disabled="!addData.member_id" v-validate="'required'" @change="getTotalMonth"
                          class="border-bottom" name="month1" v-model="month1">
                          <option value="null">Please select</option>
                          <option v-for="itemMonth in endMonthData" :key="itemMonth.id" :value="itemMonth.fullDate">
                            {{ itemMonth.name_of_month }} {{ itemMonth.year }}</option>
                        </b-form-select>
                        <span class="error">{{ errors.first('outstanding.month1') }}</span>
                      </div>
                      <div class="col-6">
                        <b-form-select :disabled="!month1" class="border-bottom" name="month2" @change="getTotalMonth"
                          v-model="month2">
                          <option value="null">Please select</option>
                          <option v-for="itemMonth in endMonthData" :key="itemMonth.id" :value="itemMonth.fullDate">
                            {{ itemMonth.name_of_month }} {{ itemMonth.year }}</option>
                        </b-form-select>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Total Month</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom bg-transparent" disabled name="outstanding_total"
                      v-validate="'required|numeric'" v-model="addData.outstanding_total" type="text"></b-form-input>
                    <span class="error">{{ errors.first('outstanding.outstanding_total') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Total Outstanding Fee</label>
                  </b-col>
                  <b-col sm="9">
                    <money class="form-control border-bottom custom-currency w-100 bg-transparent" disabled
                      v-model="addData.monthly_fee" v-bind="money2"></money>
                    <span class="error">{{ errors.first('outstanding.monthly_fee') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Late Payment</label>
                  </b-col>
                  <b-col sm="9">
                    <money class="form-control border-bottom custom-currency w-100 bg-transparent"
                      v-model="addData.late_payment" v-bind="money2"></money>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Late Payment Total</label>
                  </b-col>
                  <b-col sm="9">
                    <money class="form-control border-bottom custom-currency w-100 bg-transparent" disabled
                      v-model="addData.late_payment_total" name="late_payment_total" v-bind="money2"></money>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Payment Total</label>
                  </b-col>
                  <b-col sm="9">
                    <money :value="totalPayment" class="form-control border-bottom custom-currency w-100 bg-transparent"
                      v-model="addData.payment_total" name="payment_total" v-bind="money2"></money>
                    <span class="error">{{ errors.first('outstanding.payment_total') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Employee ID</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-select @change="getCSData" class="border-bottom" name="customer_service_id"
                      v-validate="'required'" v-model="addData.customer_service_id">
                      <option :value="null">Please select</option>
                      <option v-for="item in dataCS" :key="item.id" :value="item.id">
                        <template v-if="item.branch">{{ item.branch.codename }}</template>
                        <template v-else>XX</template>
                        -{{ item.id }}
                      </option>
                    </b-form-select>
                    <span class="error">{{ errors.first('freeze.customer_service_id') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Customer Service Name</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom bg-transparent" disabled v-model="CSName"
                      type="text"></b-form-input>
                  </b-col>
                </b-row>
              </div>
            </div>
            <!-- Member point -->
            <div class="mt-20 mb-10">
              <div class="row">
                <div class="col-lg-7">
                  <b-row class="mb-20">
                    <b-col sm="3">
                      <label>Member Point</label>
                    </b-col>
                    <b-col sm="9">
                      <money class="form-control border-bottom bg-transparent" v-model="addData.memberPoint"
                        v-bind="money2" disabled></money>
                    </b-col>
                  </b-row>
                  <b-row class="mb-20" v-if="addData.memberPoint > 0">
                    <b-col sm="3">
                      <label>Redeem Amount</label>
                    </b-col>
                    <b-col sm="9">
                      <money class="form-control border-bottom bg-transparent" v-model="addData.redeemAmount"
                        :value="redeemPayment" v-bind="money2"></money>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>
            <!-- End Member Point -->
            <div class="mt-20 mb-10">
              <div>Payment Methods</div>
              <hr class="short-line left mb-20" />
              <div class="row">
                <div class="col-lg-7">
                  <b-row class="mb-20">
                    <b-col sm="3">
                      <div>Payment 1</div>
                    </b-col>
                    <b-col sm="9">
                      <div class="mb-20">
                        <b-form-select v-validate="'required'" @change="changePaymentType1" name="payment_type_id_1"
                          v-model="addData.payment_type_id_1" class="form-control border-bottom">
                          <option :value="null" selected>Please select</option>
                          <option v-for="item in itemsPaymentType" :key="item.id" :value="item.id">{{ item.name }}
                          </option>
                        </b-form-select>
                        <span class="error">{{ errors.first('outstanding.payment_type_id_1') }}</span>
                      </div>
                      <div class="mb-10">
                        <b-form-radio-group class="radio-custom-list" @change="changePaymentCard1"
                          :disabled="[1, 6, 9].includes(addData.payment_type_id_1)" name="paymentCard1"
                          v-model="addData.payment_card_id_1">
                          <b-form-radio class="font-13" v-for="item in itemsPaymentCard" :key="item.id"
                            :value="item.id">{{
                            item.name }}</b-form-radio>
                        </b-form-radio-group>
                        <div
                          v-if="![1, 9].includes(addData.payment_type_id_1) && addData.payment_type_id_1 != null && addData.payment_card_id_1 == null">
                          <span class="error">The payment_card_id_1 field is required.</span>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div class="col-lg-5">
                  <money class="form-control border-bottom custom-currency w-100" id="paymentFirstAmount"
                    v-model="amountPaymentCard1" v-bind="money2"></money>
                  <div v-if="amountPaymentCard1 == '' || amountPaymentCard1 == null">
                    <span class="error">The payment first amount field is required.</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-7">
                  <b-row class="mb-20">
                    <b-col sm="3">
                      <div>Payment 2</div>
                    </b-col>
                    <b-col sm="9">
                      <div class="mb-20">
                        <b-form-select name="payment_type_id_2" @change="changePaymentType2"
                          v-model="addData.payment_type_id_2" class="form-control border-bottom">
                          <option :value="null" selected>Please select</option>
                          <option v-for="item in itemsPaymentType2" :key="item.id" :value="item.id">{{ item.name }}
                          </option>
                        </b-form-select>
                      </div>
                      <div class="mb-10">
                        <b-form-radio-group class="radio-custom-list" @change="changePaymentCard2"
                          :disabled="addData.payment_type_id_2 == 1 || addData.payment_type_id_2 == 6"
                          name="paymentCard2" v-model="addData.payment_card_id_2">
                          <b-form-radio class="font-13" v-for="item in itemsPaymentCard" :key="item.id"
                            :value="item.id">{{
                            item.name }}</b-form-radio>
                        </b-form-radio-group>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div class="col-lg-5">
                  <money class="form-control border-bottom custom-currency w-100 bg-transparent" disabled
                    v-model="amountPaymentCard2" :value="paymentLeft" v-bind="money2"></money>
                </div>
              </div>
              <div class="row">
                <b-col sm="2">
                  <div>Notes</div>
                </b-col>
                <b-col sm="10">
                  <textarea class="w-100" rows="5" v-model="addData.notes"></textarea>
                </b-col>
              </div>
            </div>
            <div class="text-right">
              <button type="submit" class="btn-primary">Submit</button>
            </div>
          </form>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from "@coreui/vue";
import axios from "axios";
import { Auth } from "@/api";
import moment from "moment";
import { ModelSelect } from "vue-search-select";
import Mixin from '../../mixins/memberMixin'
export default {
  name: "addOutstanding",
  components: {
    ModelSelect
  },
  mixins: [Mixin],

  data: function () {
    return {
      fullNameDetail: "",
      errorMoney: "The amount field is required!",
      dataMember: [],
      dataBranch: [],
      dataCS: [],
      config: {
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d"
      },
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 0,
        masked: false
      },
      money2: {
        decimal: ",",
        thousands: ".",
        prefix: "IDR ",
        suffix: "",
        precision: 0,
        masked: false
      },
      formType: "outstanding",
      itemsPaymentCard: [],
      itemsPaymentType: [],
      itemsPaymentType2: [],
      detailMember: {},
      detailCS: {},
      CSName: "",
      modalShow: false,
      linkPrivyId: "https://sandbox.privy.id/user",
      month1: null,
      month2: null,
      thisYear: moment(new Date()).format("YYYY"),
      monthNames: [
        {
          id: 1,
          name_of_month: "January"
        },
        {
          id: 2,
          name_of_month: "February"
        },
        {
          id: 3,
          name_of_month: "March"
        },
        {
          id: 4,
          name_of_month: "April"
        },
        {
          id: 5,
          name_of_month: "May"
        },
        {
          id: 6,
          name_of_month: "June"
        },
        {
          id: 7,
          name_of_month: "July"
        },
        {
          id: 8,
          name_of_month: "August"
        },
        {
          id: 9,
          name_of_month: "September"
        },
        {
          id: 10,
          name_of_month: "October"
        },
        {
          id: 11,
          name_of_month: "November"
        },
        {
          id: 12,
          name_of_month: "December"
        }
      ],
      getMonthData: [],
      endMonthData: [],
      branch_validate: false,
      temp_payment_total: 0,
      addData: {
        member_id: null,
        branch_id: null,
        customer_service_id: null,
        month: "",
        monthly_fee: "",
        outstanding_total: "",
        late_payment: 50000,
        late_payment_total: "",
        payment_total: "",
        payment_type_id_1: null,
        payment_card_id_1: null,
        payment_amount_1: "",
        payment_type_id_2: null,
        payment_card_id_2: null,
        payment_amount_2: "",
        notes: "",
        memberPoint: 0,
        redeemAmount: 0,
        redeem_amount: 0,
        redeem_member_id: null,
        outstanding_category_id: 1
      },
      monthlyRatePrice: "",
      addDataPrivy: {
        member_id: null,
        customer_id: null,
        branch_id: null,
        doc_name: "outstanding_form"
      },
      amountPaymentCard1: "",
      amountPaymentCard2: "",
      options: [
        { value: null, text: "Please select" },
        { value: "freeze", text: "Freeze" },
        { value: "cancel", text: "Cancel" },
        { value: "outstanding", text: "Outstanding" },
        { value: "wristband", text: "Wristband" },
        { value: "lostAndFound", text: "Lost & Found" },
        { value: "dailyVisit", text: "Daily Visit" },
        { value: "grabAndGo", text: "Grab & Go" },
        { value: "grabAndGoGopay", text: "Grab & Go Gopay" },
        { value: 'extendPt', text: 'Extend PT' },
        { value: "corporateOutstanding", text: "Corporate Invoice Outstanding" },
        { value: 'merchandise', text: 'Merchandise' },
        { value: 'starterPack', text: 'Starter Pack' }
      ],
      optionsMember: [{ value: null, text: "Please select" }]
    };
  },
  methods: {
    getTotalMonth(event) {
      if (this.month1 && this.month2) {
        this.addData.outstanding_total = this.dateRange(
          this.month1,
          this.month2
        );
      }

      this.addData.monthly_fee =
        this.detailMember.membership_last_buy_price - 2200;
      this.addData.late_payment_total =
        this.addData.late_payment * this.addData.outstanding_total;
      this.addData.payment_total =
        this.addData.outstanding_total * this.addData.monthly_fee +
        this.addData.late_payment_total;
    },
    dateRange(startDate, endDate) {
      var start = startDate.split("-");
      var end = endDate.split("-");
      var startYear = parseInt(start[0]);
      var endYear = parseInt(end[0]);
      var dates = [];

      for (var i = startYear; i <= endYear; i++) {
        var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
        var startMon = i === startYear ? parseInt(start[1]) - 1 : 0;
        for (
          var j = startMon;
          j <= endMonth;
          j = j > 12 ? j % 12 || 11 : j + 1
        ) {
          var month = j + 1;
          var displayMonth = month < 10 ? "0" + month : month;
          dates.push([i, displayMonth, "01"].join("-"));
        }
      }
      return dates.length;
    },
    changeFormType(event) {
      if (event === "freeze") {
        this.$router.push("/allForm/addFreeze");
      } else if (event === "cancel") {
        this.$router.push("/allForm/addCancel");
      } else if (event === "outstanding") {
        this.$router.push("/allForm/addOutstanding");
      } else if (event === "wristband") {
        this.$router.push("/allForm/addWristband");
      } else if (event === "lostAndFound") {
        this.$router.push("/allForm/addLostAndFound");
      } else if (event === "dailyVisit") {
        this.$router.push("/allForm/addDailyVisit");
      } else if (event === "grabAndGo") {
        this.$router.push("/allForm/addGrabAndGo");
      } else if (event === "grabAndGoGopay") {
        this.$router.push("/allForm/addgrabAndGoGopay");
      } else if (event === "corporateOutstanding") {
        this.$router.push("/allForm/addCorporateOutstanding");
      } else if (event === 'extendPt') {
        this.$router.push('/allForm/addExtendPt')
      } else if (event === 'merchandise') {
        this.$router.push('/allForm/addMerchandise')
      } else if (event === 'starterPack') {
        this.$router.push('/allForm/addStarterPack')
      } else {
        this.$router.push("/allForm/add");
      }
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    async changePaymentCard1(event) {
      let payment_card = await axios.get(
        "transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=" +
        event
      );
      this.itemsPaymentType = payment_card.data.data.rows;
    },
    async changePaymentCard2(event) {
      let payment_card = await axios.get(
        "transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=" +
        event
      );
      this.itemsPaymentType2 = payment_card.data.data.rows;
    },
    changePaymentType1(event) {
      if (event === 1) {
        this.addData.payment_card_id_1 = null;
      } else if (event === 6) {
        this.addData.payment_card_id_1 = 1;
      } else {
        this.addData.payment_card_id_1 = null;
      }
    },
    changePaymentType2(event) {
      if (event === 1) {
        this.addData.payment_card_id_2 = null;
      } else if (event === 6) {
        this.addData.payment_card_id_2 = 1;
      } else {
        this.addData.payment_card_id_2 = null;
      }
    },
    getMemberData(event) {
      axios
        .get("fitness/v1/member/" + event)
        .then(response => {
          console.log("test", response);
          this.detailMember = response.data.data;
          this.monthlyRatePrice = response.data.data.membership_last_buy_price;
          this.addDataPrivy.branch_id = response.data.data.branch_id;
          this.addDataPrivy.member_id = response.data.data.id;

          this.addData.late_payment_total =
            this.addData.late_payment * this.addData.outstanding_total;
          this.addData.monthly_fee =
            this.monthlyRatePrice * this.addData.outstanding_total;
          this.addData.payment_total =
            this.addData.monthly_fee + this.addData.late_payment_total;
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    getCSData(event) {
      axios
        .get("crm/v1/customer_service/" + event)
        .then(response => {
          this.detailCS = response.data.data;
          this.CSName = response.data.data.name;
          this.addDataPrivy.customer_id = response.data.data.id;
          // console.log('test', response)
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    formSelect(event) {
      return event;
    },
    changeValueMoney(event) {
      if (!(event.key === "")) {
        this.$refs["error-print"].classList.add("hidden");
      } else {
        this.$refs["error-print"].classList.remove("hidden");
      }
    },
    validateOutstanding(data3) {
      this.$validator.validateAll(data3).then(result => {
        if (
          ![1, 9].includes(this.addData.payment_type_id_1) &&
          this.addData.payment_card_id_1 == null
        ) {
          this.$toast.success("please fill in required fields!", "Error", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff"
          });
          return;
        }
        if (this.addData.branch_id == null) {
          this.branch_validate = true
          this.$toast.success('The Branch field is required!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
          return
        }
        if (result) {
          this.addData.payment_amount_1 = this.amountPaymentCard1;
          this.addData.payment_amount_2 = this.amountPaymentCard2;
          this.addData.month =
            moment(`${this.month1}-01`, "YYYY-MM-DD").format("MMMM") +
            " - " +
            moment(`${this.month2}-01`, "YYYY-MM-DD").format("MMMM");

          this.addData.start_outstanding = this.month1 + "-01";
          this.addData.end_outstanding = this.month2 + "-01";

          this.addData.redeem_amount = this.addData.redeemAmount
          this.addData.redeem_member_id = this.addData.member_id

          axios
            .post("crm/v1/form_outstanding/", this.addData)
            .then(response => {
              // console.log('test', response)
              this.$router.push("/allForm");
              this.$toast.success("data saved successfully!", "Success", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
            })
            .catch(error => {
              // console.log('error log', error)
              this.$toast.success("cant saved data!", "Error", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
            });
        } else {
          this.$toast.success("please fill in required fields!", "Error", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff"
          });
        }
      });
    },
    changeBranch(event) {
      this.branch_validate = false
      this.getMember()


      axios.get('crm/v1/customer_service?branch_id=' + event).then(response => {
        this.dataCS = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    },
    openPage(event) {
      this.$router.push(event);
    },
    getLastSixMonth() {
      var today = new Date();
      var dMonth;
      for (var i = 6; i >= 0; i -= 1) {
        dMonth = new Date(today.getFullYear(), today.getMonth() - i, 1);
        var rawDataMonth = this.monthNames[dMonth.getMonth()];
        var singleYear = dMonth.getFullYear();
        var singleMonth = dMonth.getMonth() + 1;
        var dataComplete = Object.assign(
          {},
          rawDataMonth,
          { year: dMonth.getFullYear() },
          { fullDate: singleYear + "-" + singleMonth }
        );
        this.getMonthData.push(dataComplete);
      }
    },
    getEndMonth() {
      var today = new Date();
      this.endMonthData = [].concat(this.getMonthData);
      // edit from 3 to 4
      for (var i = 1; i <= 16; i++) {
        var dMonth = new Date(today.getFullYear(), today.getMonth() + i, 1);
        var rawDataMonth = this.monthNames[dMonth.getMonth()];
        var singleYear = dMonth.getFullYear();
        var singleMonth = dMonth.getMonth() + 1;
        var dataComplete = Object.assign(
          {},
          rawDataMonth,
          { year: dMonth.getFullYear() },
          { fullDate: singleYear + "-" + singleMonth }
        );
        this.endMonthData.push(dataComplete);
      }
    },
    fetchData() {
      this.getLastSixMonth();
      this.getEndMonth();
      this.getMember()
      axios
        .get(
          "transaction/v1/payment_card?sorting=id&sorting_type=asc&status=active"
        )
        .then(response => {
          this.itemsPaymentCard = response.data.data.rows;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get(
          "transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=1"
        )
        .then(response => {
          this.itemsPaymentType = response.data.data.rows;
          this.itemsPaymentType2 = response.data.data.rows;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get("crm/v1/customer_service/")
        .then(response => {
          this.dataCS = response.data.data.rows;
          // console.log('test', response)
          if (Auth.Session.get().paradigm_role == 6 || Auth.Session.get().paradigm_role == '6') {
            // filter cs member
            this.dataCS = this.dataCS.filter(cs => cs.id == Auth.Session.get().paradigm_id)
          }
        })
        .catch(error => {
          console.log("error", error);
        });
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
        if (Auth.Session.get().paradigm_role == 6 || Auth.Session.get().paradigm_role == '6') {
          // filter branch member
          this.dataBranch = this.dataBranch.filter(branch => branch.id == Auth.Session.get().paradigm_branch_id)
        }
      }).catch(error => {
        console.log('error', error)
      })
      // turn off autocomplete
      if (document.getElementsByTagName) {
        var inputElements = document.getElementsByTagName("member_id");
        for (var i = 0; inputElements[i]; i++) {
          if (
            inputElements[i].className &&
            inputElements[i].className.indexOf("disableAutoComplete") != -1
          ) {
            inputElements[i].setAttribute("autocomplete", "off");
          }
        }
      }
      if (moment(new Date()).format("DD") < 15) {
        this.addData.late_payment = 0;
      } else {
        this.addData.late_payment = 50000;
      }
    }
  },
  computed: {
    getMemberId: function () {
      return this.addData.member_id;
    },
    latePayment() {
      return this.addData.late_payment;
    },
    totalPayment: function () {
      // let calculatedTotal = this.addData.payment_total;
      // this.amountPaymentCard1 = this.addData.payment_total;

      // if (this.addData.redeemAmount > 0 && this.addData.payment_total > 0) {
      //   this.addData.payment_total = calculatedTotal - this.addData.redeemAmount
      //   this.amountPaymentCard1 = this.addData.payment_total
      // }
      // return calculatedTotal;

      const baseTotal = this.addData.monthly_fee + this.addData.late_payment + this.addData.late_payment_total;
      const redeem = this.addData.redeemAmount || 0;

      const finalTotal = Math.round((baseTotal - redeem));

      this.amountPaymentCard1 = finalTotal;
      this.addData.payment_total = finalTotal

      return finalTotal;

    },
    paymentLeft: function () {
      if (
        String(this.amountPaymentCard1).length >
        String(this.addData.payment_total).length
      ) {
        // console.log('test')
        this.amountPaymentCard2 = 0;
      } else {
        this.amountPaymentCard2 =
          this.addData.payment_total - this.amountPaymentCard1;
        this.amountPaymentCard2 = Math.abs(this.amountPaymentCard2);
      }
    },
    redeemPayment: function () {
      if (this.addData.redeemAmount > this.addData.memberPoint) {
        this.$toast.success("Not enough point", "Error", {
          position: "topCenter",
          icon: "icon-envelope",
          progressBarColor: "rgb(0, 255, 184)",
          theme: "dark",
          backgroundColor: "#565c70",
          messageColor: "#fff"
        });
        this.addData.redeemAmount = 0;
        return this.addData.redeemAmount
      } else {
        return this.addData.redeemAmount
      }
    },
    // getMemberId: function() {
    //   return this.addData.member_id;
    // }
  },
  watch: {
    latePayment() {
      this.addData.late_payment_total =
        this.addData.late_payment * this.addData.outstanding_total;
      this.addData.payment_total =
        this.addData.monthly_fee + this.addData.late_payment_total;
    },
    getMemberId() {
      axios
        .get("fitness/v1/member/" + this.addData.member_id)
        .then(response => {
          this.detailMember = response.data.data;
          this.fullNameDetail =
            response.data.data.first_name + " " + response.data.data.last_name;
          this.addDataPrivy.branch_id = response.data.data.branch_id;
          this.addDataPrivy.member_id = response.data.data.id;
        })
        .catch(error => {
          console.log("error", error);
        });

      axios.get("mobile/v1/my_rewards/total_rewards?member_id=" + this.addData.member_id)
        .then(response => {
          this.addData.memberPoint = response.data.data[0].total_amount
        })
        .catch(error => {
          console.log("error", error);
        })
    },
  },
  created() {
    this.fetchData();

    const roleId = Auth.Session.get().paradigm_role
    if (roleId == 6 || roleId == '6') {
      this.addData.branch_id = Auth.Session.get().paradigm_branch_id
      this.addData.customer_service_id = Auth.Session.get().paradigm_id

      this.getCSData(this.addData.customer_service_id)
    }
  }
};
</script>

<style></style>
